<template>
    <div class="media">
        <div class="pageHeader">

          <div class="pageTitle">
            <span class="pageTitleText">דף המדיה</span>
          </div>
          <!-- <div class="topLine">
            <ul>
              <li :class="[yesterdayItemNav == true ? 'activeItem' : '']"><a href="#" @click="yesterdayOrders()">אתמול</a></li>
              <li :class="[todayItemNav == true ? 'activeItem' : '']"><a href="#" @click="todayOrders()">היום</a></li>
              <li :class="[tommorowItemNav == true ? 'activeItem' : '']"><a href="#" @click="tommorowOrders()">מחר</a></li>
              <li @click="loadOrdersRealTime()" class="getOrders"><i class="material-icons">refresh</i> <span>רענן הזמנות</span></li>
            </ul>
          </div> -->
          <div class="searchData">
            <div class="searchBox">
              <!-- <label>חיפוש לפי שם או מספר טלפון</label> -->
              <i class="material-icons">search</i>
              <input type="text" placeholder="חיפוש לפי שם או מספר טלפון" v-model="txtSearch">
            </div>
            <!-- <div class="datesBox">
              <div class="filterByDate">
                
                <div class="dateField">
                  <input type="date" v-model="fromDate" @change="loadOrders()">
                </div>
                <span>עד</span>
                <div class="dateField">
                  <input type="date" v-model="toDate" @change="loadOrders()">
                </div>
              </div>

            </div> -->
          </div>
        </div>
        <div class="imagesCollection">
            <div class="imgCard" v-for="(image,index) in images" :key="index">
                <img :src="image.Data.image" >
                <div class="details">
                    <span class="name">{{ image.Data.fullname }}</span>
                    <span class="orderNumber">#{{ image.Data.orderNumber }}</span>
                </div>
                <div class="created">
                    <i class="material-icons">calendar_month</i> <span class="createdDate">{{ image.Data.date }}</span>
                </div>
            
            </div>
        </div>
        
    </div>
</template>
<script>
    import { db } from '../firebase';
    import firebase from "firebase/app";
    import moment from 'moment';

export default {
  name: 'Media',
  data () {
    return {
        txtSearch:'',
        images:[]
    }
  },
  created(){
    let vm = this;
    vm.loadImages();
  },
  methods:{
    loadImages(){
        let vm = this;
        db.collection("Media").orderBy('date','asc').get().then((result)=>{
            for(let i = 0; i < result.size; i++){
                let image = result.docs[i].data();
                let imageId = result.docs[i].id;
                vm.images.push({ ID: imageId, Data: image });
            }
           
        }).catch((error)=>{
            console.log("Error loading Images >>>", error);
        })
    },
    printDiv(divId) {
     var printContents = document.getElementById(divId).innerHTML;
     var originalContents = document.body.innerHTML;

     document.body.innerHTML = printContents;

     window.print();

     document.body.innerHTML = originalContents;
}
  }

}
</script>

<style>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.media{
    padding: 1rem;
}
.pageHeader{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.pageTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.pageTitle .pageTitleText ,
.pageTitle .pageOrdersCounterText{
  color: #141c29;
  font-family: 'Noto Sans Hebrew';
}
.pageTitle .pageTitleText{
  font-size: 24px;
  font-weight: bold;
}
.pageTitle .pageOrdersCounterText{
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  left: 0rem;
}
.searchData{
  width: 100%;
  padding: 1rem;
  background-color: #f4f5f8;
  border-radius: 8px;
  display: flex;
  margin-bottom: 10px;
}
.searchBox{
  width: 50%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}
.searchBox i{
  position: absolute;
    right: 10px;
    font-size: 20px;
    line-height: 40px;
    color: #B4B9C7;
}
.searchBox input[type=text]{
  width: 100%;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #B4B9C7;
  background-color: #fff;
  height: 40px;
  color: #141c29;
  font-size: 14px;
  padding-right: 40px;
  font-family: 'Noto Sans Hebrew';
  line-height: 40px;

}
.imagesCollection{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
}
.imgCard{
    background-color: #FFF;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 15px;
    overflow: hidden;
    padding: 1.25rem;
    position: relative;
    transition: .15s ease-in;
    margin-bottom: 25px;
}
.imgCard:hover{
    transform: translateY(-5px);
}
.imgCard img{
    width: 100%;
	max-width: 250px;
    border-radius: 10px;
	overflow: hidden;
    min-height: 250px;
    max-height: 250px;
    object-fit: cover;
}
.details{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid #f4f5f8;
}
.details span{
    width: calc(100% / 2 - 5px);
    color: #141c29;
    font-size: 15px;
    font-weight: 500;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
}
.details .name{
    text-align: right;
}
.details .orderNumber{
    text-align: left;
}
.created{
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
}
.created .createdDate{
    font-size: 14px;
    color: #141c29;
    margin-right: 10px;
}
.created i{
    color: #ccc;
    font-size: 18px;
}
@media screen and (max-width: 500px) {
  .searchBox{
    width: 100%;

  }
  .imgCard img {
    width: 100%;
    max-width: 150px;
    min-width: 150px;
    border-radius: 10px;
    overflow: hidden;
    min-height: 200px;
    max-height: 200px;
    -o-object-fit: cover;
    object-fit: cover;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/Media.vue